import React, { Fragment, useState, useRef, useEffect } from "react"
import { accessRole } from "../../../../../helpers/access_role"
import apiResponse from "../../../../../services/apiResponse"
import classnames from "classnames"
import { Link } from "react-router-dom"

import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button, Input, Label,
    Nav,
    NavItem,
    NavLink,
    TabContent,
    TabPane,
} from "reactstrap"

import Select from "../../../../../helpers/ui/CustomSelect"

import IndexBloc from './Blocs/IndexBloc'
import TableActiveComponent from './Components/TableActiveComponent'
import TableDoneComponent from './Components/TableDoneComponent'
import moment from "moment"
import DatePicker from "../../../../../helpers/ui/DatePicker"

const IndexView = (props) => {

    let indexBloc = new IndexBloc();

    const [activeTab, setactiveTab] = useState("1")

    const [periode, setPeriode] = useState(
        {
            start_date: moment().startOf('month').format('YYYY-MM-DD'),
            end_date: moment().endOf('month').format('YYYY-MM-DD')
        }
    )
    // const [params, setParams] = useState([])

    const activeRef = useRef();
    const doneRef = useRef();

    const reloadActiveRef = () => { if (activeRef.current) activeRef.current.setTokenAPI() }
    const reloadDoneRef = () => { if (doneRef.current) doneRef.current.setTokenAPI() }

    function search() {
        reloadActiveRef()
        reloadDoneRef()
    }

    useEffect(() => {
        search()
    }, [periode])

    function reset() {
        setPeriode({ start_date: '', end_date: '' })
        setTimeout(() => {
            reloadActiveRef()
            reloadDoneRef()
        }, 300);
    }

    function toggle(tab) {
        if (activeTab !== tab) {
            setactiveTab(tab)
        }
    }

    let params = {
        start_date: periode?.start_date,
        end_date: periode?.end_date,
    }

    return (
        <Fragment>
            <Container fluid>
                <Card>
                    <CardBody>
                        <div className="float-end">
                            {
                                (accessRole('create')) ?
                                    <Link to="?create">
                                        <Button color="primary">Buat Koreksi Kehadiran</Button>
                                    </Link>
                                    : null
                            }
                        </div>
                        <CardTitle>List Koreksi Kehadiran</CardTitle>
                        <CardSubtitle className="mb-3">
                            Daftar Seluruh Koreksi Kehadiran
                        </CardSubtitle>
                        <hr />
                        <Row className="mb-1">
                            <label className="col-md-3">
                                Periode Mulai
                            </label>
                            <Col md="3">
                                {/* <Input
                                    name="start_period"
                                    placeholder="Periode Mulai..."
                                    type="date"
                                    errorMessage="Masukkan Periode Mulai"
                                    className="form-control"
                                    id="start_period"
                                    value={periode?.start_date}
                                    onChange={event => setPeriode({...periode, start_date: event.target.value })}
                                /> */}
                                <DatePicker
                                    name="start_date"
                                    isWeekday={false}
                                    dateFormat="dd/MM/yyyy"
                                    placeholder="Tanggal Mulai"
                                    isAvForm={false}
                                    onChange={val => setPeriode({ ...periode, start_date: moment(val).format('YYYY-MM-DD') })}
                                    defaultValue={periode?.start_date}
                                />
                            </Col>
                        </Row>
                        <Row className="mb-2">
                            <label className="col-md-3">
                                Periode Akhir
                            </label>
                            <Col md="3">
                                {/* <Input
                                    name="end_period"
                                    placeholder="Periode Akhir..."
                                    type="date"
                                    errorMessage="Masukkan Periode Akhir"
                                    className="form-control"
                                    id="end_period"
                                    value={periode?.end_date}
                                    onChange={event => setPeriode({...periode, end_date: event.target.value })}
                                /> */}
                                <DatePicker
                                    name="end_date"
                                    isWeekday={false}
                                    dateFormat="dd/MM/yyyy"
                                    placeholder="Tanggal Mulai"
                                    isAvForm={false}
                                    onChange={val => setPeriode({ ...periode, end_date: moment(val).format('YYYY-MM-DD') })}
                                    defaultValue={periode?.end_date}
                                />
                            </Col>
                        </Row>
                        <Row className="mb-1">
                            <Col md="3"></Col>
                            <Col md="6">
                                <Button
                                    color="warning"
                                    type="button"
                                    onClick={() => {
                                        reset()
                                    }}
                                >
                                    <i className="uil-refresh"></i> Reset
                                </Button>
                            </Col>
                        </Row>
                        <hr />

                        <Nav tabs>
                            <NavItem>
                                <NavLink
                                    style={{ cursor: "pointer" }}
                                    className={classnames({
                                        active: activeTab === "1",
                                    })}
                                    onClick={() => {
                                        toggle("1")
                                    }}
                                >
                                    <span className="d-block d-sm-none"><i className="fas fa-home"></i></span>
                                    <span className="d-none d-sm-block">Menunggu Proses</span>
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink
                                    style={{ cursor: "pointer" }}
                                    className={classnames({
                                        active: activeTab === "2",
                                    })}
                                    onClick={() => {
                                        toggle("2")
                                    }}
                                >
                                    <span className="d-block d-sm-none"><i className="far fa-envelope"></i></span>
                                    <span className="d-none d-sm-block">Diproses</span>
                                </NavLink>
                            </NavItem>
                        </Nav>
                        <TabContent activeTab={activeTab} className="p-3 text-muted">
                            <TabPane tabId="1">
                                <TableActiveComponent ref={activeRef} params={params} />
                            </TabPane>
                            <TabPane tabId="2">
                                <TableDoneComponent ref={doneRef} params={params} />
                            </TabPane>
                        </TabContent>

                    </CardBody>
                </Card>
            </Container>
        </Fragment>
    )

}

export default IndexView